// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: src/styles/NavigationBar.css */

/* ──────────────────────────────────────────────
   Top bar
   ────────────────────────────────────────────── */
.top-bar{
  --nav-primary:#214734;
  --nav-primary-600:#173326;
  --nav-surface:#fffdf8;
  --nav-border:#e7dccc;
  --nav-accent:#c89a3c;
  --nav-focus:rgba(33,71,52,.18);
  --nav-font-sans:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
  --nav-mobile-safe-top:env(safe-area-inset-top, 0px);
  --nav-mobile-content-height:64px;

  display:none;
  position:fixed;
  top:0; left:0;
  box-sizing:border-box;
  width:100%;
  height:calc(var(--nav-mobile-content-height) + var(--nav-mobile-safe-top));
  background:
    linear-gradient(135deg,rgba(255,253,248,.98),rgba(241,230,212,.92)),
    var(--nav-surface);
  padding:var(--nav-mobile-safe-top) 1rem 0;
  align-items:center;
  gap:.75rem;
  z-index:200;
  border-bottom:1px solid rgba(91,72,48,.16);
  box-shadow:0 12px 30px rgba(47,39,29,.08);
  font-family:var(--nav-font-sans);
}

@media (min-width:901px){
  .top-bar{
    left:220px;
    width:calc(100% - 220px);
    padding:0 24px;
  }

  .top-bar--has-product-summary{
    display:flex;
    opacity:0;
    transform:translateY(-100%);
    pointer-events:none;
    transition:opacity .16s ease,transform .16s ease;
  }

  .top-bar--product-summary-visible{
    opacity:1;
    transform:translateY(0);
    pointer-events:auto;
  }

  .top-bar .hamburger,
  .top-bar .mobile-top-filter-btn{
    display:none;
  }

  .top-bar-product-summary{
    max-width:min(760px,100%);
    flex:0 1 760px;
  }
}
.hamburger{
  -webkit-appearance:none;
          appearance:none;
  display:grid;
  place-items:center;
  width:48px;
  min-width:48px;
  height:48px;
  padding:0;
  border:1px solid rgba(35,40,32,.12);
  border-radius:8px;
  background:#fff;
  color:var(--nav-primary);
  cursor:pointer;
}
.hamburger-icon{
  display:grid;
  grid-gap:5px;
  gap:5px;
  width:20px;
}
.hamburger-icon span{
  display:block;
  width:100%;
  height:3px;
  border-radius:999px;
  background:currentColor;
}
.hamburger:hover,
.hamburger:focus-visible{
  border-color:rgba(18,63,42,.3);
  box-shadow:0 0 0 4px var(--nav-focus);
  outline:0;
}
.top-bar-product-summary{
  display:grid;
  grid-template-columns:38px minmax(0,1fr);
  align-items:center;
  grid-gap:9px;
  gap:9px;
  flex:1 1 auto;
  min-width:0;
  height:100%;
  opacity:0;
  transform:translateY(-10px);
  transition:opacity .16s ease,transform .16s ease;
  pointer-events:none;
}
.top-bar-product-summary--visible{
  opacity:1;
  transform:translateY(0);
}
.top-bar-product-summary__image{
  width:38px;
  height:38px;
  padding:3px;
  border:1px solid #ececec;
  border-radius:8px;
  background:#fff;
  object-fit:contain;
}
.top-bar-product-summary__copy{
  display:grid;
  grid-gap:2px;
  gap:2px;
  min-width:0;
}
.top-bar-product-summary__brand{
  color:#8c6742;
  font-size:.65rem;
  font-weight:850;
  line-height:1.15;
  text-transform:uppercase;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.top-bar-product-summary__name{
  color:#172018;
  font-size:.78rem;
  font-weight:800;
  line-height:1.18;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.mobile-top-filter-btn{
  min-height:44px;
  background:var(--nav-primary);
  color:#fff;
  border:1px solid var(--nav-primary);
  border-radius:8px;
  padding:8px 14px;
  font-weight:850;
  font-size:.86rem;
  cursor:pointer;
  box-shadow:0 12px 24px rgba(33,71,52,.18);
}
.mobile-top-filter-btn:hover{background:var(--nav-primary-600);}

/* Stop background scroll when sidebar open */
body.nav-open{position:fixed;width:100%;height:100%;overflow:hidden;}

/* ──────────────────────────────────────────────
   Sidebar
   ────────────────────────────────────────────── */
.sidebar{
  --nav-bg:#f7f3ec;
  --nav-surface:#fffdf8;
  --nav-surface-strong:#fff;
  --nav-muted:#6f6a60;
  --nav-muted-2:#948c7e;
  --nav-text:#172119;
  --nav-border:#e7dccc;
  --nav-border-strong:#d5c4af;
  --nav-primary:#214734;
  --nav-primary-600:#173326;
  --nav-accent:#c89a3c;
  --nav-clay:#a86444;
  --nav-radius:8px;
  --nav-shadow:0 22px 60px rgba(47,39,29,.12);
  --nav-shadow-2:0 12px 30px rgba(47,39,29,.08);
  --nav-focus:rgba(33,71,52,.18);
  --nav-font-display:Georgia,"Times New Roman",serif;
  --nav-font-sans:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;

  position:fixed;
  top:0; bottom:0; left:0;
  width:220px;
  height:100dvh; max-height:100dvh;
  overflow-y:auto;
  -webkit-overflow-scrolling:touch;
  overscroll-behavior:contain;
  scrollbar-gutter:stable;
  background:
    radial-gradient(circle at 40% 0,rgba(255,255,255,.9),rgba(255,255,255,0) 240px),
    linear-gradient(180deg,rgba(238,231,220,.94),rgba(250,248,244,.86) 430px),
    var(--nav-bg);
  color:var(--nav-text);
  display:flex;
  flex-direction:column;
  align-items:stretch;
  padding:14px 10px calc(2rem + env(safe-area-inset-bottom));
  border-right:1px solid rgba(91,72,48,.16);
  box-shadow:var(--nav-shadow-2);
  z-index:100;
  transition:left .3s ease;
  font-family:var(--nav-font-sans);
  -webkit-font-smoothing:antialiased;
  -moz-osx-font-smoothing:grayscale;
}

.sidebar::before{
  content:"";
  position:absolute;
  inset:0;
  pointer-events:none;
  background:
    linear-gradient(90deg,rgba(200,154,60,.08),transparent 45%),
    repeating-linear-gradient(90deg,rgba(91,72,48,.025) 0 1px,transparent 1px 34px);
}

.sidebar h2{
  position:relative;
  margin:0 6px 16px;
  padding:14px 14px 15px;
  border:1px solid rgba(91,72,48,.14);
  border-radius:var(--nav-radius);
  background:rgba(255,253,248,.76);
  color:var(--nav-text);
  font-family:var(--nav-font-display);
  font-size:1.62rem;
  font-weight:500;
  line-height:1;
  letter-spacing:0;
  text-align:left;
  box-shadow:0 10px 28px rgba(47,39,29,.07);
}

.sidebar h2::after{
  content:"";
  display:block;
  width:42px;
  height:3px;
  margin-top:10px;
  border-radius:999px;
  background:linear-gradient(90deg,var(--nav-accent),var(--nav-clay));
}

.sidebar nav{
  position:relative;
  z-index:1;
}

.sidebar nav ul{list-style:none;padding:0;margin:0;width:100%;}
.sidebar nav ul li{
  display:block;
  padding:0 2px;
  margin:0 0 3px;
}
.sidebar nav ul li a,
.sidebar nav ul li button{
  -webkit-appearance:none;
          appearance:none;
  display:flex;
  align-items:center;
  width:100%;
  min-height:36px;
  color:var(--nav-text);
  text-decoration:none;
  padding:8px 10px;
  border:1px solid transparent;
  border-radius:var(--nav-radius);
  background:transparent;
  cursor:pointer;
  text-align:left;
  font:inherit;
  font-size:.86rem;
  font-weight:800;
  line-height:1.2;
  overflow-wrap:anywhere;
  transition:background .16s ease,border-color .16s ease,color .16s ease,box-shadow .16s ease,transform .16s ease;
}
.sidebar nav ul li a:hover,
.sidebar nav ul li button:hover,
.sidebar nav ul li a:focus-visible,
.sidebar nav ul li button:focus-visible{
  border-color:rgba(18,63,42,.24);
  background:var(--nav-surface-strong);
  color:var(--nav-primary);
  box-shadow:0 0 0 4px var(--nav-focus);
  outline:0;
}
.sidebar nav ul li a:active,
.sidebar nav ul li button:active{
  transform:translateY(1px);
}

.sidebar nav ul li:first-child a{
  background:var(--nav-primary);
  border-color:var(--nav-primary);
  color:#fff;
  box-shadow:0 10px 22px rgba(33,71,52,.16);
}

.sidebar nav ul li:first-child a:hover,
.sidebar nav ul li:first-child a:focus-visible{
  background:var(--nav-primary-600);
  color:#fff;
}

.sidebar nav ul li:last-child{
  margin-top:12px;
  padding-top:12px;
  border-top:1px solid var(--nav-border);
}

.sidebar nav ul li:last-child button{
  color:var(--nav-clay);
}

/* Close icon (mobile) */
.mobile-close{
  display:none;
  position:absolute;
  top:16px;
  right:16px;
  z-index:120;
  width:42px;
  height:42px;
  border:1px solid rgba(35,40,32,.12);
  border-radius:8px;
  background:#fff;
  color:var(--nav-primary);
  font-size:2rem;
  line-height:36px;
  text-align:center;
  cursor:pointer;
}

.mobile-close:hover,
.mobile-close:focus-visible{
  border-color:rgba(18,63,42,.3);
  box-shadow:0 0 0 4px var(--nav-focus);
}

/* ──────────────────────────────────────────────
   Mobile & Tablet (<=900px)
   Sidebar becomes drawer; top bar appears
   ────────────────────────────────────────────── */
@media (max-width:900px){
  .top-bar{display:flex;}
  .sidebar{
    width:100%;
    left:-100%;
    padding:calc(78px + env(safe-area-inset-top, 0px)) 14px calc(2rem + env(safe-area-inset-bottom));
    z-index:300;
  }
  .sidebar.open{left:0;}
  .mobile-close{display:block;}
}

/* ──────────────────────────────────────────────
   Hierarchy / toggle styles
   ────────────────────────────────────────────── */
.nav-section-heading{
  min-height:34px;
  margin-top:.55rem;
  margin-bottom:2px;
  padding:7px 8px;
  border:1px solid transparent;
  border-radius:7px;
  background:transparent;
  color:var(--nav-clay);
  cursor:pointer;
  -webkit-user-select:none;
          user-select:none;
  display:flex;
  justify-content:space-between;
  align-items:center;
  gap:10px;
  font-size:.72rem;
  font-weight:850;
  line-height:1.2;
  text-transform:uppercase;
  transition:background .16s ease,border-color .16s ease,color .16s ease,box-shadow .16s ease;
}
.sidebar nav ul li.nav-section-heading{
  display:flex;
}
.nav-section-heading > span:first-child{flex:1 1;}
.nav-section-heading:hover,
.nav-section-heading:focus-visible{
  border-color:rgba(18,63,42,.16);
  background:rgba(255,253,248,.74);
  color:var(--nav-primary);
  box-shadow:0 0 0 4px var(--nav-focus);
  outline:0;
}
.nav-toggle-icon{
  display:grid;
  place-items:center;
  width:22px;
  height:22px;
  flex:0 0 22px;
  margin-left:0;
  border:1px solid rgba(33,71,52,.16);
  border-radius:999px;
  background:rgba(255,255,255,.82);
  color:var(--nav-primary);
  font-size:.98rem;
  font-weight:850;
  line-height:1;
  pointer-events:none;
  box-shadow:0 4px 12px rgba(47,39,29,.06);
}
.sidebar nav ul li.nav-sub-item a{
  position:relative;
  min-height:32px;
  margin-left:8px;
  padding-left:28px;
  color:var(--nav-muted);
  font-size:.82rem;
  font-weight:750;
}
.sidebar nav ul li.nav-sub-item a::before{
  content:"";
  position:absolute;
  left:13px;
  top:50%;
  width:5px;
  height:5px;
  border-radius:999px;
  background:var(--nav-accent);
  transform:translateY(-50%);
  pointer-events:none;
}

@media (max-width:560px){
  .top-bar{
    gap:.55rem;
    padding:var(--nav-mobile-safe-top) .75rem 0;
  }

  .top-bar-product-summary{
    grid-template-columns:34px minmax(0,1fr);
    gap:7px;
  }

  .top-bar-product-summary__image{
    width:34px;
    height:34px;
    padding:3px;
  }

  .top-bar-product-summary__brand{
    font-size:.6rem;
  }

  .top-bar-product-summary__name{
    font-size:.72rem;
  }

  .sidebar h2{
    margin-right:58px;
  }

  .sidebar nav ul li a,
  .sidebar nav ul li button{
    min-height:42px;
    font-size:.92rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/NavigationBar.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;;mDAEmD;AACnD;EACE,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,8BAA8B;EAC9B,sEAAsE;EACtE,mDAAmD;EACnD,gCAAgC;;EAEhC,YAAY;EACZ,cAAc;EACd,KAAK,EAAE,MAAM;EACb,qBAAqB;EACrB,UAAU;EACV,0EAA0E;EAC1E;;sBAEoB;EACpB,yCAAyC;EACzC,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;IACxB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,gDAAgD;EAClD;;EAEA;IACE,SAAS;IACT,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;AACF;AACA;EACE,uBAAe;UAAf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,WAAW;EACX,SAAS;EACT,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,UAAU;AACZ;AACA;EACE,aAAa;EACb,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;EAEE,8BAA8B;EAC9B,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,YAAO;EAAP,OAAO;EACP,aAAa;EACb,WAAW;EACX,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,gDAAgD;EAChD,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAO;EAAP,OAAO;EACP,WAAW;AACb;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,UAAU;EACV,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;AACA,6BAA6B,iCAAiC,CAAC;;AAE/D,6CAA6C;AAC7C,cAAc,cAAc,CAAC,UAAU,CAAC,WAAW,CAAC,eAAe,CAAC;;AAEpE;;mDAEmD;AACnD;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,6CAA6C;EAC7C,8BAA8B;EAC9B,kDAAkD;EAClD,sEAAsE;;EAEtE,cAAc;EACd,KAAK,EAAE,QAAQ,EAAE,MAAM;EACvB,WAAW;EACX,aAAa,EAAE,iBAAiB;EAChC,eAAe;EACf,gCAAgC;EAChC,2BAA2B;EAC3B,uBAAuB;EACvB;;;iBAGe;EACf,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,0DAA0D;EAC1D,yCAAyC;EACzC,8BAA8B;EAC9B,WAAW;EACX,wBAAwB;EACxB,gCAAgC;EAChC,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,OAAO;EACP,mBAAmB;EACnB;;mFAEiF;AACnF;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,mCAAmC;EACnC,+BAA+B;EAC/B,gCAAgC;EAChC,qBAAqB;EACrB,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,aAAa;EACb,UAAU;EACV,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,mEAAmE;AACrE;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA,gBAAgB,eAAe,CAAC,SAAS,CAAC,QAAQ,CAAC,UAAU,CAAC;AAC9D;EACE,aAAa;EACb,aAAa;EACb,cAAc;AAChB;AACA;;EAEE,uBAAe;UAAf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;EAC/B,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,+GAA+G;AACjH;AACA;;;;EAIE,+BAA+B;EAC/B,oCAAoC;EACpC,wBAAwB;EACxB,qCAAqC;EACrC,SAAS;AACX;AACA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,UAAU;EACV,yCAAyC;AAC3C;;AAEA;;EAEE,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,iBAAiB;EACjB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,UAAU;EACV,WAAW;EACX,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;;;mDAGmD;AACnD;EACE,SAAS,YAAY,CAAC;EACtB;IACE,UAAU;IACV,UAAU;IACV,gGAAgG;IAChG,WAAW;EACb;EACA,cAAc,MAAM,CAAC;EACrB,cAAc,aAAa,CAAC;AAC9B;;AAEA;;mDAEmD;AACnD;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EACd,wBAAgB;UAAhB,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,2FAA2F;AAC7F;AACA;EACE,YAAY;AACd;AACA,wCAAwC,QAAM,CAAC;AAC/C;;EAEE,+BAA+B;EAC/B,gCAAgC;EAChC,wBAAwB;EACxB,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,gCAAgC;EAChC,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,SAAS;EACT,OAAO;EACP,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,4BAA4B;EAC5B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;EAC7C;;EAEA;IACE,wCAAwC;IACxC,OAAO;EACT;;EAEA;IACE,UAAU;IACV,WAAW;IACX,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["/* File: src/styles/NavigationBar.css */\n\n/* ──────────────────────────────────────────────\n   Top bar\n   ────────────────────────────────────────────── */\n.top-bar{\n  --nav-primary:#214734;\n  --nav-primary-600:#173326;\n  --nav-surface:#fffdf8;\n  --nav-border:#e7dccc;\n  --nav-accent:#c89a3c;\n  --nav-focus:rgba(33,71,52,.18);\n  --nav-font-sans:-apple-system,BlinkMacSystemFont,\"Segoe UI\",sans-serif;\n  --nav-mobile-safe-top:env(safe-area-inset-top, 0px);\n  --nav-mobile-content-height:64px;\n\n  display:none;\n  position:fixed;\n  top:0; left:0;\n  box-sizing:border-box;\n  width:100%;\n  height:calc(var(--nav-mobile-content-height) + var(--nav-mobile-safe-top));\n  background:\n    linear-gradient(135deg,rgba(255,253,248,.98),rgba(241,230,212,.92)),\n    var(--nav-surface);\n  padding:var(--nav-mobile-safe-top) 1rem 0;\n  align-items:center;\n  gap:.75rem;\n  z-index:200;\n  border-bottom:1px solid rgba(91,72,48,.16);\n  box-shadow:0 12px 30px rgba(47,39,29,.08);\n  font-family:var(--nav-font-sans);\n}\n\n@media (min-width:901px){\n  .top-bar{\n    left:220px;\n    width:calc(100% - 220px);\n    padding:0 24px;\n  }\n\n  .top-bar--has-product-summary{\n    display:flex;\n    opacity:0;\n    transform:translateY(-100%);\n    pointer-events:none;\n    transition:opacity .16s ease,transform .16s ease;\n  }\n\n  .top-bar--product-summary-visible{\n    opacity:1;\n    transform:translateY(0);\n    pointer-events:auto;\n  }\n\n  .top-bar .hamburger,\n  .top-bar .mobile-top-filter-btn{\n    display:none;\n  }\n\n  .top-bar-product-summary{\n    max-width:min(760px,100%);\n    flex:0 1 760px;\n  }\n}\n.hamburger{\n  appearance:none;\n  display:grid;\n  place-items:center;\n  width:48px;\n  min-width:48px;\n  height:48px;\n  padding:0;\n  border:1px solid rgba(35,40,32,.12);\n  border-radius:8px;\n  background:#fff;\n  color:var(--nav-primary);\n  cursor:pointer;\n}\n.hamburger-icon{\n  display:grid;\n  gap:5px;\n  width:20px;\n}\n.hamburger-icon span{\n  display:block;\n  width:100%;\n  height:3px;\n  border-radius:999px;\n  background:currentColor;\n}\n.hamburger:hover,\n.hamburger:focus-visible{\n  border-color:rgba(18,63,42,.3);\n  box-shadow:0 0 0 4px var(--nav-focus);\n  outline:0;\n}\n.top-bar-product-summary{\n  display:grid;\n  grid-template-columns:38px minmax(0,1fr);\n  align-items:center;\n  gap:9px;\n  flex:1 1 auto;\n  min-width:0;\n  height:100%;\n  opacity:0;\n  transform:translateY(-10px);\n  transition:opacity .16s ease,transform .16s ease;\n  pointer-events:none;\n}\n.top-bar-product-summary--visible{\n  opacity:1;\n  transform:translateY(0);\n}\n.top-bar-product-summary__image{\n  width:38px;\n  height:38px;\n  padding:3px;\n  border:1px solid #ececec;\n  border-radius:8px;\n  background:#fff;\n  object-fit:contain;\n}\n.top-bar-product-summary__copy{\n  display:grid;\n  gap:2px;\n  min-width:0;\n}\n.top-bar-product-summary__brand{\n  color:#8c6742;\n  font-size:.65rem;\n  font-weight:850;\n  line-height:1.15;\n  text-transform:uppercase;\n  overflow:hidden;\n  text-overflow:ellipsis;\n  white-space:nowrap;\n}\n.top-bar-product-summary__name{\n  color:#172018;\n  font-size:.78rem;\n  font-weight:800;\n  line-height:1.18;\n  overflow:hidden;\n  text-overflow:ellipsis;\n  white-space:nowrap;\n}\n.mobile-top-filter-btn{\n  min-height:44px;\n  background:var(--nav-primary);\n  color:#fff;\n  border:1px solid var(--nav-primary);\n  border-radius:8px;\n  padding:8px 14px;\n  font-weight:850;\n  font-size:.86rem;\n  cursor:pointer;\n  box-shadow:0 12px 24px rgba(33,71,52,.18);\n}\n.mobile-top-filter-btn:hover{background:var(--nav-primary-600);}\n\n/* Stop background scroll when sidebar open */\nbody.nav-open{position:fixed;width:100%;height:100%;overflow:hidden;}\n\n/* ──────────────────────────────────────────────\n   Sidebar\n   ────────────────────────────────────────────── */\n.sidebar{\n  --nav-bg:#f7f3ec;\n  --nav-surface:#fffdf8;\n  --nav-surface-strong:#fff;\n  --nav-muted:#6f6a60;\n  --nav-muted-2:#948c7e;\n  --nav-text:#172119;\n  --nav-border:#e7dccc;\n  --nav-border-strong:#d5c4af;\n  --nav-primary:#214734;\n  --nav-primary-600:#173326;\n  --nav-accent:#c89a3c;\n  --nav-clay:#a86444;\n  --nav-radius:8px;\n  --nav-shadow:0 22px 60px rgba(47,39,29,.12);\n  --nav-shadow-2:0 12px 30px rgba(47,39,29,.08);\n  --nav-focus:rgba(33,71,52,.18);\n  --nav-font-display:Georgia,\"Times New Roman\",serif;\n  --nav-font-sans:-apple-system,BlinkMacSystemFont,\"Segoe UI\",sans-serif;\n\n  position:fixed;\n  top:0; bottom:0; left:0;\n  width:220px;\n  height:100dvh; max-height:100dvh;\n  overflow-y:auto;\n  -webkit-overflow-scrolling:touch;\n  overscroll-behavior:contain;\n  scrollbar-gutter:stable;\n  background:\n    radial-gradient(circle at 40% 0,rgba(255,255,255,.9),rgba(255,255,255,0) 240px),\n    linear-gradient(180deg,rgba(238,231,220,.94),rgba(250,248,244,.86) 430px),\n    var(--nav-bg);\n  color:var(--nav-text);\n  display:flex;\n  flex-direction:column;\n  align-items:stretch;\n  padding:14px 10px calc(2rem + env(safe-area-inset-bottom));\n  border-right:1px solid rgba(91,72,48,.16);\n  box-shadow:var(--nav-shadow-2);\n  z-index:100;\n  transition:left .3s ease;\n  font-family:var(--nav-font-sans);\n  -webkit-font-smoothing:antialiased;\n  -moz-osx-font-smoothing:grayscale;\n}\n\n.sidebar::before{\n  content:\"\";\n  position:absolute;\n  inset:0;\n  pointer-events:none;\n  background:\n    linear-gradient(90deg,rgba(200,154,60,.08),transparent 45%),\n    repeating-linear-gradient(90deg,rgba(91,72,48,.025) 0 1px,transparent 1px 34px);\n}\n\n.sidebar h2{\n  position:relative;\n  margin:0 6px 16px;\n  padding:14px 14px 15px;\n  border:1px solid rgba(91,72,48,.14);\n  border-radius:var(--nav-radius);\n  background:rgba(255,253,248,.76);\n  color:var(--nav-text);\n  font-family:var(--nav-font-display);\n  font-size:1.62rem;\n  font-weight:500;\n  line-height:1;\n  letter-spacing:0;\n  text-align:left;\n  box-shadow:0 10px 28px rgba(47,39,29,.07);\n}\n\n.sidebar h2::after{\n  content:\"\";\n  display:block;\n  width:42px;\n  height:3px;\n  margin-top:10px;\n  border-radius:999px;\n  background:linear-gradient(90deg,var(--nav-accent),var(--nav-clay));\n}\n\n.sidebar nav{\n  position:relative;\n  z-index:1;\n}\n\n.sidebar nav ul{list-style:none;padding:0;margin:0;width:100%;}\n.sidebar nav ul li{\n  display:block;\n  padding:0 2px;\n  margin:0 0 3px;\n}\n.sidebar nav ul li a,\n.sidebar nav ul li button{\n  appearance:none;\n  display:flex;\n  align-items:center;\n  width:100%;\n  min-height:36px;\n  color:var(--nav-text);\n  text-decoration:none;\n  padding:8px 10px;\n  border:1px solid transparent;\n  border-radius:var(--nav-radius);\n  background:transparent;\n  cursor:pointer;\n  text-align:left;\n  font:inherit;\n  font-size:.86rem;\n  font-weight:800;\n  line-height:1.2;\n  overflow-wrap:anywhere;\n  transition:background .16s ease,border-color .16s ease,color .16s ease,box-shadow .16s ease,transform .16s ease;\n}\n.sidebar nav ul li a:hover,\n.sidebar nav ul li button:hover,\n.sidebar nav ul li a:focus-visible,\n.sidebar nav ul li button:focus-visible{\n  border-color:rgba(18,63,42,.24);\n  background:var(--nav-surface-strong);\n  color:var(--nav-primary);\n  box-shadow:0 0 0 4px var(--nav-focus);\n  outline:0;\n}\n.sidebar nav ul li a:active,\n.sidebar nav ul li button:active{\n  transform:translateY(1px);\n}\n\n.sidebar nav ul li:first-child a{\n  background:var(--nav-primary);\n  border-color:var(--nav-primary);\n  color:#fff;\n  box-shadow:0 10px 22px rgba(33,71,52,.16);\n}\n\n.sidebar nav ul li:first-child a:hover,\n.sidebar nav ul li:first-child a:focus-visible{\n  background:var(--nav-primary-600);\n  color:#fff;\n}\n\n.sidebar nav ul li:last-child{\n  margin-top:12px;\n  padding-top:12px;\n  border-top:1px solid var(--nav-border);\n}\n\n.sidebar nav ul li:last-child button{\n  color:var(--nav-clay);\n}\n\n/* Close icon (mobile) */\n.mobile-close{\n  display:none;\n  position:absolute;\n  top:16px;\n  right:16px;\n  z-index:120;\n  width:42px;\n  height:42px;\n  border:1px solid rgba(35,40,32,.12);\n  border-radius:8px;\n  background:#fff;\n  color:var(--nav-primary);\n  font-size:2rem;\n  line-height:36px;\n  text-align:center;\n  cursor:pointer;\n}\n\n.mobile-close:hover,\n.mobile-close:focus-visible{\n  border-color:rgba(18,63,42,.3);\n  box-shadow:0 0 0 4px var(--nav-focus);\n}\n\r\n/* ──────────────────────────────────────────────\n   Mobile & Tablet (<=900px)\n   Sidebar becomes drawer; top bar appears\n   ────────────────────────────────────────────── */\n@media (max-width:900px){\n  .top-bar{display:flex;}\n  .sidebar{\n    width:100%;\n    left:-100%;\n    padding:calc(78px + env(safe-area-inset-top, 0px)) 14px calc(2rem + env(safe-area-inset-bottom));\n    z-index:300;\n  }\n  .sidebar.open{left:0;}\n  .mobile-close{display:block;}\n}\n\n/* ──────────────────────────────────────────────\n   Hierarchy / toggle styles\r\n   ────────────────────────────────────────────── */\r\n.nav-section-heading{\n  min-height:34px;\n  margin-top:.55rem;\n  margin-bottom:2px;\n  padding:7px 8px;\n  border:1px solid transparent;\n  border-radius:7px;\n  background:transparent;\n  color:var(--nav-clay);\n  cursor:pointer;\n  user-select:none;\n  display:flex;\n  justify-content:space-between;\n  align-items:center;\n  gap:10px;\n  font-size:.72rem;\n  font-weight:850;\n  line-height:1.2;\n  text-transform:uppercase;\n  transition:background .16s ease,border-color .16s ease,color .16s ease,box-shadow .16s ease;\n}\n.sidebar nav ul li.nav-section-heading{\n  display:flex;\n}\n.nav-section-heading > span:first-child{flex:1;}\n.nav-section-heading:hover,\n.nav-section-heading:focus-visible{\n  border-color:rgba(18,63,42,.16);\n  background:rgba(255,253,248,.74);\n  color:var(--nav-primary);\n  box-shadow:0 0 0 4px var(--nav-focus);\n  outline:0;\n}\n.nav-toggle-icon{\n  display:grid;\n  place-items:center;\n  width:22px;\n  height:22px;\n  flex:0 0 22px;\n  margin-left:0;\n  border:1px solid rgba(33,71,52,.16);\n  border-radius:999px;\n  background:rgba(255,255,255,.82);\n  color:var(--nav-primary);\n  font-size:.98rem;\n  font-weight:850;\n  line-height:1;\n  pointer-events:none;\n  box-shadow:0 4px 12px rgba(47,39,29,.06);\n}\n.sidebar nav ul li.nav-sub-item a{\n  position:relative;\n  min-height:32px;\n  margin-left:8px;\n  padding-left:28px;\n  color:var(--nav-muted);\n  font-size:.82rem;\n  font-weight:750;\n}\n.sidebar nav ul li.nav-sub-item a::before{\n  content:\"\";\n  position:absolute;\n  left:13px;\n  top:50%;\n  width:5px;\n  height:5px;\n  border-radius:999px;\n  background:var(--nav-accent);\n  transform:translateY(-50%);\n  pointer-events:none;\n}\n\n@media (max-width:560px){\n  .top-bar{\n    gap:.55rem;\n    padding:var(--nav-mobile-safe-top) .75rem 0;\n  }\n\n  .top-bar-product-summary{\n    grid-template-columns:34px minmax(0,1fr);\n    gap:7px;\n  }\n\n  .top-bar-product-summary__image{\n    width:34px;\n    height:34px;\n    padding:3px;\n  }\n\n  .top-bar-product-summary__brand{\n    font-size:.6rem;\n  }\n\n  .top-bar-product-summary__name{\n    font-size:.72rem;\n  }\n\n  .sidebar h2{\n    margin-right:58px;\n  }\n\n  .sidebar nav ul li a,\n  .sidebar nav ul li button{\n    min-height:42px;\n    font-size:.92rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
